
import axios from 'axios';

import {
  defineComponent,
  ref,
  reactive,
  onMounted,
} from 'vue';

import type {
  ErrorsMap,
  Projects,
  Site,
} from '@/types';

import {
  ENTRIES,
  TRAFFIC_CATEGORY_ADULT,
  TRAFFIC_CATEGORIES,
  SITE_APPROVAL_STATUS_APPROVED,
  SITE_APPROVAL_STATUSES,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useEntries from '@/composable/useEntries';

import useEntriesNext from '@/composable/useEntries@next';

export default defineComponent({
  setup() {
    const { activeUser: user } = useUser();

    const { getEntryByRoute } = useEntries();

    const {
      entries: projects,
      entriesLoading: projectsLoading,
      fetchEntries: fetchProjects,
    } = useEntriesNext<Projects>('/api/project/getProjects', ENTRIES);

    const site = reactive<Site>({
      traffic_category: TRAFFIC_CATEGORY_ADULT,
      approval_status: SITE_APPROVAL_STATUS_APPROVED,
      comment: null,
    });

    const siteErrorsMap = ref<ErrorsMap>({});

    const fetchSite = async (): Promise<void> => {
      const entry = await getEntryByRoute('/api/site/getSiteById');

      if (entry) {
        Object.assign(site, entry);
      }
    };

    const storeSite = async (): Promise<void> => {
      const response = await axios.post('/api/site/storeSite', site);

      Object.assign(site, response.data);
    };

    const onProjectChange = (): void => {
      site.user_id = undefined;
    };

    onMounted((): void => {
      Promise.all([
        user.isSuperAdmin() ? fetchProjects() : Promise.resolve(),
      ]);
    });

    return {
      TRAFFIC_CATEGORIES,
      SITE_APPROVAL_STATUSES,
      user,
      projectsLoading,
      projects,
      site,
      siteErrorsMap,
      fetchSite,
      storeSite,
      onProjectChange,
    };
  },
});
